import { Boost } from '../../../types/models/boosts/boosts.types';
import { BOOSTS_ENDPOINTS } from '../../../utils/api/endpoints/boostsEndpoints';

const PREFIX = '[allBoostsQuery]';

export const allBoostsQuery = async () => {
  console.log(PREFIX, `Fetching all boosts...`);

  const response = await BOOSTS_ENDPOINTS.getAll();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received all boosts..`);
  return json as Boost[];
};
